import React, { useState, useEffect } from 'react';

import AgGridReact from 'ui/AgGridReact/AgGridReact';
import TextFloatingFilter from 'ui/AgGridReact/TextFloatingFilter';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import RadioCellRenderer from './RadioCellRenderer';
import { sideBar } from 'routes/BudgetModule/components/BudgetProposal/Resource/ExpenseIncome/gridHelpers/gridHelpers';

type Props<T> = {
    dataRows: T[];
    selectedRow: T | null | undefined;
    setSelectedRow: (arg1: T) => void;
    columns: ColDef<T>[];
    pagination?: boolean;
    paginationPageSize?: number;
};
function RadioCellSelector<T>({
    dataRows,
    selectedRow,
    setSelectedRow,
    columns,
    pagination = false,
    paginationPageSize = 0,
}: Props<T>): React.ReactElement {
    const [gridApi, setGridApi] = useState<GridApi | null>(null);
    const colDefs: ColDef[] = [
        {
            field: '',
            cellRenderer: 'radioCellRenderer',
            suppressHeaderMenuButton: true,
            editable: false,
            suppressNavigable: true,
            minWidth: 60,
            maxWidth: 60,
            pinned: 'left',
            suppressSizeToFit: true,
            suppressColumnsToolPanel: true,
            resizable: false,
            suppressMovable: true,
            cellRendererParams: {
                setSelected: setSelectedRow,
            },
        },

        ...columns.map((col) => ({
            ...col,
            filter: 'agTextColumnFilter',
            floatingFilterComponent: 'textFloatingFilter',
            resizable: true,
            sortable: true,
            field: col.field,
            floatingFilter: true,
            suppressFloatingFilterButton: true,
            menuTabs: [
                'filterMenuTab' as const,
                'generalMenuTab' as const,
                'columnsMenuTab' as const,
            ],
        })),
    ];

    useEffect(() => {
        if (gridApi) {
            // This will update the radio buttons
            gridApi.refreshCells({ force: true });
            gridApi.sizeColumnsToFit();
            gridApi.resetRowHeights();
        }
    }, [selectedRow, gridApi]);

    const onGridReady = (params: GridReadyEvent) => {
        params.api.sizeColumnsToFit();
        params.api.resetRowHeights();
        params.api.setGridOption('domLayout', 'autoHeight');
        setGridApi(params.api);
    };

    return (
        <div className="ag-theme-material">
            <AgGridReact
                sideBar={sideBar}
                rowHeight={36}
                headerHeight={40}
                rowData={dataRows}
                columnDefs={colDefs}
                components={{
                    radioCellRenderer: RadioCellRenderer,
                    textFloatingFilter: TextFloatingFilter,
                }}
                context={{ selected: selectedRow }}
                onGridReady={onGridReady}
                pagination={pagination}
                paginationPageSize={paginationPageSize}
            />
        </div>
    );
}

export default RadioCellSelector;
